import { Button, Container, Divider, Menu, MenuButton, MenuItemOption, MenuList } from '@chakra-ui/react';
import IconArrowDown from 'assets/icons/icon-arrow-simple-down.svg?react';
import HeaderBar from 'components/ui/HeaderBar';
import SearchBar from 'components/ui/SearchBar';
import SearchProvider from 'contexts/SearchContext';
import { useNavigate } from 'react-router-dom';
import ContentGroupsList from '../components/ContentGroupsList';

export default function PageContentGroups() {
  const navigate = useNavigate();

  return (
    <SearchProvider
      searchKey="contentGroups"
      searchPath="/content-groups"
    >
      <HeaderBar 
        title="Modelos de Disparo"
        description="Visualize a lista de Modelos de Disparo e Produtos Patri"
      >
        <Menu>
          <MenuButton 
            as={Button}
            variant="primary"
            rightIcon={<IconArrowDown />}
          >
            Cadastrar novo
          </MenuButton>
          <MenuList>
            <MenuItemOption onClick={() => navigate(`/modelos-de-disparo/novo/AGENDA`)}>
              Agenda
            </MenuItemOption>
            <MenuItemOption onClick={() => navigate(`/modelos-de-disparo/novo/REPORT`)}>
              Report
            </MenuItemOption>
          </MenuList>
        </Menu>
      </HeaderBar>
      
      <Divider />
      
      <Container flexDirection="column">
        <SearchBar placeholder="Digite para buscar" />
        <ContentGroupsList />
      </Container>
    </SearchProvider>
  )
}
